// Deterministic series/slice colours for generic insights charts.
//
// A domain can lock specific series keys to brand colours via the
// `InsightsProvider` colour map (e.g. donation categories on NEX-587); any key
// not in the map falls back to a stable palette colour chosen by its index, so a
// brand-new domain renders sensibly with zero configuration.

export type InsightsColourMap = Record<string, string>

// The Lemonade chart palette (Figma node 5676:1946), ordered for categorical use.
export const CHART_PALETTE_SEQUENCE: readonly string[] = [
  '#8B4AFF', // octopus
  '#FF7557', // fox
  '#81E1DA', // frog
  '#F8BD3B', // canary
  '#B3596F', // lobster
  '#72BEF4', // jay
  '#FFB27A', // tiger
  '#0F7EA0', // kingfisher
]

/** Resolves a series/slice colour: the domain's locked colour if mapped, else palette-by-index. */
export const resolveColour = (
  key: string,
  index: number,
  colourMap: InsightsColourMap
): string =>
  colourMap[key] ??
  CHART_PALETTE_SEQUENCE[index % CHART_PALETTE_SEQUENCE.length]
